import axios from "axios";
import constant from 'config/serverUrl';

const api = axios.create({
  baseURL: constant.REACT_APP_SERVER_URL,
});

//  Add authorization header to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

//  dont thow error on 4XX status codes
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);
export default api;
